import { fetchTrendingFromGQL } from "./graphql";
import TrendingFactory from "./TrendingFactory";

export const { getSection, hasTrending, getTrendingSection, usingCaML } =
    TrendingFactory(fetchTrendingFromGQL);
